import React, { useRef, useEffect, useState } from "react"
import { Link } from "react-router-dom"
import html2canvas from "html2canvas"
import { LuDownload } from "react-icons/lu"
import QRCode from "qrcode.react"
import JSZip from "jszip" // JSZip to create zip files
import InvitesmartLogonew from "@/assets/images/invitesmartLogoneww.png"
import QRGenerator from "@/pages/addInvite/generateQrCode"
import { useTranslation } from "react-i18next"
import { RgbToHex } from "@/pages/addInvite/displayColor"
import NameLabel from "@/pages/addInvite/nameLabel"

export const hexToRgb = (hex: string): string => {
  // Remove the hash if present
  const cleanedHex = hex.replace("#", "")

  // Extract RGB components
  const bigint = parseInt(cleanedHex, 16)
  const r = (bigint >> 16) & 255
  const g = (bigint >> 8) & 255
  const b = bigint & 255

  return `rgb(${r}, ${g}, ${b})`
}
import LoaderBar from "../../LoaderBar"

const fonts = [
  {
    name: "NotoSans_regular",
    label: "Noto Sans",
    fontFamily: "'Noto Sans', sans-serif",
  },
  { name: "Rubik_regular", label: "Rubik", fontFamily: "'Rubik', sans-serif" },
  { name: "Amiri_regular", label: "Amiri", fontFamily: "'Amiri', serif" },
  { name: "Cairo_regular", label: "Cairo", fontFamily: "'Cairo', sans-serif" },
  {
    name: "ScheherazadeNew_regular",
    label: "Scheherazade",
    fontFamily: "'Scheherazade', serif",
  },
  {
    name: "MarkaziText_regular",
    label: "Markazi",
    fontFamily: "'Markazi Text', serif",
  },

  { name: "Lora_regular", label: "Lora", fontFamily: "'Lora', serif" },
  {
    name: "Montserrat_regular",
    label: "Montserrat",
    fontFamily: "'Montserrat', sans-serif",
  },
]
const getFontFamily = (fontName: string) => {
  const font = fonts.find((font: any) => font?.name === fontName)
  return font?.fontFamily || "default-font, sans-serif" // Fallback font
}
const normalizePosition = (
  value: number,
  maxValue: number,
  defaultLower: number,
  defaultUpper: number,
) => {
  if (value < 0) return defaultLower * maxValue // Below bounds
  if (value > 1) return defaultUpper * maxValue // Above bounds
  return value * maxValue // Within bounds
}

const getImageSizeFromUrl = (
  imageUrl: string,
): Promise<{ width: number; height: number }> => {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.src = imageUrl

    img.onload = () => {
      resolve({ width: img.naturalWidth, height: img.naturalHeight })
    }

    img.onerror = (err) => {
      reject(err)
    }
  })
}

const DownloadImageWithOverlaysSingle = ({
  nameOrNumberArray,
  event,
  setShowDownloadInvites,
  qrCodeData,
}: {
  nameOrNumberArray: any[]
  event?: any
  setShowDownloadInvites: (value: any) => void
  qrCodeData?: any
}) => {
  const [loading, setLOading] = useState(false)
  const { t } = useTranslation()
  const containerRef = useRef<HTMLDivElement | null>(null)

  const [imageContainerWidth, setImageContainerWidth] = useState(300)
  const [imageContainerHeight, setImageContainerHeight] = useState(300)

  const [guestHash, setGuestHash] = useState(nameOrNumberArray[0].hash)
  const uploadedImageRef = useRef<HTMLImageElement | null>(null)
  ///references
  const qrDivRef = useRef<HTMLDivElement | null>(null)
  const logoDivRef = useRef<HTMLImageElement | null>(null)
  const nameDivRef = useRef<HTMLImageElement | null>(null)

  // qr postioning
  const [qrPosition, setQrPosition] = useState({ x: 5, y: 2 })
  const [qrValue, setQrValue] = useState<string>("Hello ")
  const [qrSize, setQrSize] = useState(50)
  ///name managing
  const [namePosition, setNamePosition] = useState({ x: 5, y: 30 })
  console.log("namePosition", namePosition)
  const [nameSize, setNameSize] = useState(16)
  /////logo positioning
  const [logoPosition, setLogoPosition] = useState({ x: 100, y: 2 })

  useEffect(() => {
    if (
      containerRef.current &&
      qrCodeData &&
      qrDivRef.current &&
      nameDivRef.current &&
      logoDivRef.current
    ) {
      const {
        x_qr,
        y_qr,
        logo_position_x,
        logo_position_y,
        qr_size,
        name_position_x,
        name_position_y,
        name_size,
      } = qrCodeData
      // const imageWidth = containerRef.current.offsetWidth
      // const imageHeight = containerRef.current.offsetHeight
      const imageWidth =
        qrCodeData?.image_width < 400 ? qrCodeData?.image_width : 400
      const imageHeight = qrCodeData?.image_height
      setImageContainerWidth(imageWidth)
      setImageContainerHeight(imageHeight)

      const qrCodeWidth = qrDivRef.current.offsetWidth
      const qrCodeHeight = qrDivRef.current.offsetHeight
      const nameWidth = nameDivRef.current.offsetWidth
      const nameHeight = nameDivRef.current.offsetHeight
      const logoWidth = logoDivRef.current.offsetWidth
      const logoHeight = logoDivRef.current.offsetHeight
      // Normalize QR code position and constrain within image boundaries
      setQrSize(qr_size * imageWidth)
      setQrPosition({
        x: constrainPosition(
          normalizePosition(x_qr ?? 0, imageWidth, 0.1, 0.9),
          imageWidth,
          qrCodeWidth,
        ),
        y: constrainPosition(
          normalizePosition(y_qr ?? 0, imageHeight, 0.1, 0.9),
          imageHeight,
          qrCodeHeight,
        ),
      })

      //////name positioning
      if (
        name_position_x !== null &&
        name_position_y !== null &&
        name_size !== null
      ) {
        setNameSize(name_size)
        setNamePosition({
          x: constrainPosition(
            normalizePosition(name_position_x, imageWidth, 0.1, 0.9),
            imageWidth,
            nameWidth,
          ),
          y: constrainPosition(
            normalizePosition(name_position_y, imageHeight, 0.1, 0.9),
            imageHeight,
            nameHeight,
          ),
        })
      }

      // Normalize Logo position (assuming similar constraints for the logo)
      setLogoPosition({
        x: constrainPosition(
          normalizePosition(logo_position_x ?? 0, imageWidth, 0.1, 0.9),
          imageWidth,
          logoWidth, // Adjust if logo size differs
        ),
        y: constrainPosition(
          normalizePosition(logo_position_y ?? 0, imageHeight, 0.1, 0.9),
          imageHeight,
          logoHeight, // Adjust if logo size differs
        ),
      })
      // setDefaultQrSize(qrCodeData?.data?.data?.qr_size * imageWidth);
    }

    // Helper function to constrain position
    function constrainPosition(
      position: number,
      containerSize: number,
      elementSize: number,
    ) {
      const min = 0 // Start of the container
      const max = containerSize - elementSize // End of the container minus the element's size
      return Math.min(Math.max(position, min), max)
    }
  }, [containerRef.current, qrCodeData, qrDivRef.current])

  /////resize image for the first time it miunts
  // useEffect(() => {
  //   if (qrCodeData) {
  //     // Example usage:
  //     getImageSizeFromUrl(qrCodeData?.image_url)
  //       .then(({ width, height }) => {
  //         console.log("Original Image Width:", width)
  //         console.log("Original Image Height:", height)

  //         setImageContainerWidth(width)
  //         setImageContainerHeight(height)
  //         if (
  //           containerRef.current &&
  //           qrCodeData &&
  //           qrDivRef.current &&
  //           nameDivRef.current &&
  //           logoDivRef.current
  //         ) {
  //           const {
  //             x_qr,
  //             y_qr,
  //             logo_position_x,
  //             logo_position_y,
  //             qr_size,
  //             name_position_x,
  //             name_position_y,
  //             name_size,
  //           } = qrCodeData
  //           const qrCodeWidth = qrDivRef.current.offsetWidth
  //           const qrCodeHeight = qrDivRef.current.offsetHeight
  //           const nameWidth = nameDivRef.current.offsetWidth
  //           const nameHeight = nameDivRef.current.offsetHeight
  //           const logoWidth = logoDivRef.current.offsetWidth
  //           const logoHeight = logoDivRef.current.offsetHeight
  //           // Normalize QR code position and constrain within image boundaries
  //           setQrSize(qrCodeData?.qr_size * width)
  //           setQrPosition({
  //             x: constrainPosition(
  //               normalizePosition(x_qr ?? 0, width, 0.1, 0.9),
  //               width,
  //               qrCodeWidth,
  //             ),
  //             y: constrainPosition(
  //               normalizePosition(y_qr ?? 0, height, 0.1, 0.9),
  //               height,
  //               qrCodeHeight,
  //             ),
  //           })

  //           //////name positioning
  //           if (
  //             qrCodeData?.name_position_x !== null &&
  //             qrCodeData?.name_position_y !== null &&
  //             qrCodeData?.name_size !== null
  //           ) {
  //             setNameSize(qrCodeData?.name_size * width)
  //             setNamePosition({
  //               x: constrainPosition(
  //                 normalizePosition(
  //                   qrCodeData?.name_position_x ?? 0,
  //                   width,
  //                   0.1,
  //                   0.9,
  //                 ),
  //                 width,
  //                 nameWidth,
  //               ),
  //               y: constrainPosition(
  //                 normalizePosition(name_position_y ?? 0, height, 0.1, 0.9),
  //                 height,
  //                 nameHeight,
  //               ),
  //             })
  //           }
  //           // Normalize Logo position (assuming similar constraints for the logo)
  //           setLogoPosition({
  //             x: constrainPosition(
  //               normalizePosition(logo_position_x ?? 0, width, 0.1, 0.9),
  //               width,
  //               logoWidth, // Adjust if logo size differs
  //             ),
  //             y: constrainPosition(
  //               normalizePosition(logo_position_y ?? 0, height, 0.1, 0.9),
  //               height,
  //               logoHeight, // Adjust if logo size differs
  //             ),
  //           })
  //         }
  //         // Helper function to constrain position
  //         function constrainPosition(
  //           position: number,
  //           containerSize: number,
  //           elementSize: number,
  //         ) {
  //           const min = 0 // Start of the container
  //           const max = containerSize - elementSize // End of the container minus the element's size
  //           return Math.min(Math.max(position, min), max)
  //         }
  //       })
  //       .catch((err) => {
  //         console.error("Failed to load image:", err)
  //       })
  //   }
  // }, [qrCodeData, containerRef.current])
  ;("")
  // const guestHashValue = useRef(nameOrNumberArray[0].hash)
  const downloadImage = async () => {
    setLOading(true)
    if (containerRef.current) {
      const canvas = await html2canvas(containerRef.current, {
        useCORS: true,
        backgroundColor: null,
      })

      canvas.toBlob((blob) => {
        if (blob) {
          const link = document.createElement("a")
          link.href = URL.createObjectURL(blob)
          link.download = `invite_${nameOrNumberArray[0].first_name}.png`
          link.click()
          URL.revokeObjectURL(link.href)
        }
      })
    }
    setLOading(false)
  }
  useEffect(() => {
    const preloadImage = (src: string) =>
      new Promise<void>((resolve) => {
        const img = new Image()
        img.crossOrigin = "anonymous"
        img.src = src
        img.onload = () => resolve()
      })

    preloadImage(qrCodeData?.image_url)
  }, [qrCodeData?.image_url])

  return (
    <div>
      {/* Single Display */}

      {[1, "1"].includes(qrCodeData?.outside_image) ? (
        <div>
          {/* Download Button */}
          <div className="mt-3 mb-2 d-flex flex-column justify-content-center align-items-center">
            {loading ? (
              <div>
                <span className=" " style={{ fontSize: "16px" }}>
                  Loading...
                </span>
                <LoaderBar />
              </div>
            ) : (
              <Link
                className=""
                onClick={downloadImage}
                style={{
                  backgroundColor: "#245192",
                  color: "#ffffff",
                  fontSize: "14px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "8px 10px",
                  borderRadius: "10px",
                  textDecoration: "none",
                  cursor: "pointer",
                  fontFamily: "Inter",
                }}
                to="#"
              >
                <LuDownload
                  style={{
                    fontSize: "20px",
                    marginRight: "5px",
                    marginLeft: "5px",
                  }}
                />
                {/* <span className="ms-1 me-1"> {t("invitation.saveAll")} </span> */}
                <span className="ms-1 me-1"> Save Guest</span>
              </Link>
            )}
          </div>
          <div
            ref={containerRef}
            style={{
              position: "relative",
              width: qrCodeData?.image_width,
              height: qrCodeData?.image_height + 90, // border: "1px solid #ccc",
              backgroundColor: "#fff",
            }}
          >
            {/* Image section */}
            <div
              style={{
                width: imageContainerWidth,
                height: imageContainerHeight,

                // width: qrCodeData?.image_width,
                // height: qrCodeData?.image_height,

                // maxWidth: "400px",
                // maxHeight: "300px",

                // width: "400px",
                // height: "300px", // Adjust height to accommodate the image
              }}
            >
              <img
                src={qrCodeData?.image_url}
                alt="Main Background"
                style={{
                  // width: "100%",
                  // height: "100%",
                  // width: qrCodeData?.image_width,
                  // height: qrCodeData?.image_height,
                  width: imageContainerWidth,
                  height: imageContainerHeight,
                  objectFit: "cover",
                  objectPosition: "center",
                }}
              />
            </div>

            {/* QR Code and Logo Section */}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "flex-end", // Align items to the bottom
                justifyContent: "space-between",
                // padding: "5px",
              }}
            >
              {/* QR Code */}
              <div
                className="d-flex  flex-row gap-2 "
                style={{
                  alignItems: "flex-end", // Align items to the bottom
                }}
              >
                <QRGenerator
                  value={`https://mazoom.app/check-qrcode/${event?.event_id}/${nameOrNumberArray[0].hash}}`}
                  bgColor={
                    qrCodeData?.qr_color_code
                      ? RgbToHex(hexToRgb(qrCodeData?.qr_color_code))
                      : "#000000"
                  }
                  size={70}
                />
                <div className="mb-2">
                  <NameLabel
                    label={nameOrNumberArray[0]?.first_name}
                    color={RgbToHex(qrCodeData?.name_color || "#000000")}
                    size={nameSize}
                    font={getFontFamily(qrCodeData?.font_type)}
                  />
                </div>
              </div>

              {/* Logo */}
              {!qrCodeData?.remove_logo && (
                <img
                  src={InvitesmartLogonew}
                  alt="Logo"
                  style={{
                    marginBottom: "5px",
                    marginTop: "10px",
                    width: "60px",
                    height: "60px",
                    objectFit: "cover",
                    objectPosition: "center",
                  }}
                />
              )}
            </div>
          </div>
        </div>
      ) : (
        <div>
          {/* Download Button */}
          <div className="mt-3 mb-2 d-flex flex-column justify-content-center align-items-center">
            {loading ? (
              <div>
                <span className=" " style={{ fontSize: "16px" }}>
                  Loading...
                </span>
                <LoaderBar />
              </div>
            ) : (
              <Link
                className=""
                onClick={downloadImage}
                style={{
                  backgroundColor: "#245192",
                  color: "#ffffff",
                  fontSize: "14px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "8px 10px",
                  borderRadius: "10px",
                  textDecoration: "none",
                  cursor: "pointer",
                  fontFamily: "Inter",
                }}
                to="#"
              >
                <LuDownload
                  style={{
                    fontSize: "20px",
                    marginRight: "5px",
                    marginLeft: "5px",
                  }}
                />
                {/* <span className="ms-1 me-1"> {t("invitation.saveAll")} </span> */}
                <span className="ms-1 me-1"> Save Guest</span>
              </Link>
            )}
          </div>
          <div
            ref={containerRef}
            style={{
              position: "relative",

              // width: "400px",
              // height: "300px",
              // width: imageContainerWidth,
              // height: imageContainerHeight,

              width: imageContainerWidth,
              height: imageContainerHeight,
              // width: qrCodeData?.image_width,
              // height: qrCodeData?.image_height,
              // border: "1px solid #ccc",
              marginBottom: "20px",
            }}
          >
            {/* Main Image */}
            <img
              src={qrCodeData?.image_url}
              alt="Main Background"
              style={{
                width: "100%",
                height: "100%",
                position: "absolute",
                objectFit: "cover",
                objectPosition: "center",

                top: 0,
                left: 0,
              }}
            />
            {/* QR Code */}
            <div
              className="d-flex  flex-column gap-0 align-items-center"
              ref={qrDivRef}
              style={{
                position: "absolute",
                // left: `${qrX * 280}px`,
                // top: `${qrY * 300}px`,
                left: `${qrPosition?.x}px`,
                top: `${qrPosition?.y}px`,
              }}
            >
              <QRGenerator
                value={`https://mazoom.app/check-qrcode/${event?.event_id}/${nameOrNumberArray[0].hash}}`}
                bgColor={
                  qrCodeData?.qr_color_code
                    ? RgbToHex(hexToRgb(qrCodeData?.qr_color_code))
                    : "#000000"
                }
                size={qrSize}
              />
            </div>

            {/* Name or Number (Dynamic) */}
            <div
              ref={nameDivRef}
              className="d-flex  flex-column gap-0 align-items-center"
              style={{
                position: "absolute",
                top: `${namePosition.y}px`,
                left: `${namePosition.x}px`,
              }}
            >
              <NameLabel
                label={nameOrNumberArray[0]?.first_name}
                color={RgbToHex(qrCodeData?.name_color || "#000000")}
                size={nameSize}
                font={getFontFamily(qrCodeData?.font_type)}
              />
            </div>
            {/* Logo */}
            {!qrCodeData?.remove_logo && (
              <img
                ref={logoDivRef}
                src={InvitesmartLogonew}
                alt="Logo"
                style={{
                  position: "absolute",
                  // left: `${logoX * 400}px`,
                  // top: `${logoY * 300}px`,

                  // left: `${logoX < 1 ? logoX * 400 : 0.8 * 400}px`,
                  // top: `${logoY < 1 ? logoY * 300 : 0.8 * 300}px`,
                  left: `${logoPosition?.x}px`,
                  top: `${logoPosition?.y}px`,

                  // width: "60px",
                  // height: "60px",
                  width: "40px",
                  height: "50px",

                  // objectFit: "cover",
                  // objectPosition: "center",
                }}
              />
            )}
          </div>
        </div>
      )}
      <hr />
    </div>
  )
}

export default DownloadImageWithOverlaysSingle
